import { useState } from "react";
import { Link } from "react-router-dom";
import SpecialOrderModal from "./specialOrderModal";
import logoImg from "../assets/logo-navbar.png";
import { BsWhatsapp, BsInstagram, BsTiktok } from "react-icons/bs";
import { FiFacebook } from "react-icons/fi";
import { FaRegCopyright } from "react-icons/fa";
import styles from "../styles/footer.module.css";

const Footer = () => {
  const [openSpecial, setOpenSpecial] = useState(false);

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div>
          <Link to="/" className={styles.brand} aria-label="فَذَكِّرْ — الصفحة الرئيسية">
            <img src={logoImg} alt="فَذَكِّرْ" className={styles.brandLogo} />
          </Link>

          <p className={styles.tagline}>
            من جدارٍ فارغ… إلى ركن يبعث السكينة. لوحات إسلامية تذكّر القلوب وتضيء البيوت
          </p>

          <div className={styles.socials}>
            <a href="https://wa.me/972543255575" target="_blank" rel="noreferrer" aria-label="واتساب">
              <BsWhatsapp />
            </a>
            <a href="https://www.instagram.com/fa_zakir.canvas/" target="_blank" rel="noreferrer" aria-label="انستغرام">
              <BsInstagram />
            </a>
            <a href="https://www.facebook.com/share/16rR98YckG/" target="_blank" rel="noreferrer" aria-label="فيسبوك">
              <FiFacebook data-stroke="true" style={{ fill: "none" }} />
            </a>
            <a href="https://www.tiktok.com/@fa_zakir.canvas/" target="_blank" rel="noreferrer" aria-label="تيك توك">
              <BsTiktok />
            </a>
          </div>
        </div>

        <div>
          <div className={styles.colTitle}>روابط</div>
          <div className={styles.colLinks}>
            <Link to="/">الرئيسية</Link>
            <Link to="/products">جميع اللوحات</Link>
            <Link to="/wishlist">المفضلة</Link>
            <Link to="/cart">سلة التسوق</Link>
          </div>
        </div>

        <div>
          <div className={styles.colTitle}>خدماتنا</div>
          <div className={styles.colLinks}>
            <button type="button" className={styles.linkBtn} onClick={() => setOpenSpecial(true)}>
              تصميم خاص
            </button>
            <Link to="/wall-preview">تجربة على حائطك (AR)</Link>
            <Link to="/orders">تتبع الطلب</Link>
            <Link to="/account">حسابك</Link>
          </div>
        </div>

        <div>
          <div className={styles.colTitle}>تواصل معنا</div>
          <div className={styles.colLinks}>
            <a href="https://wa.me/972543255575" target="_blank" rel="noreferrer">واتساب</a>
            <a href="https://www.instagram.com/fa_zakir.canvas/" target="_blank" rel="noreferrer">انستغرام</a>
            <a href="https://www.facebook.com/share/16rR98YckG/" target="_blank" rel="noreferrer">فيسبوك</a>
            <a href="https://www.tiktok.com/@fa_zakir.canvas/" target="_blank" rel="noreferrer">تيك توك</a>
          </div>

          <div className={styles.payments}>
            <span className={styles.visa}>VISA</span>
            <span className={styles.pay}>Pay</span>
            <span>mada</span>
          </div>
        </div>
      </div>

      <div className={styles.bottom}>
        <FaRegCopyright /> فَذَكِّرْ. جميع الحقوق محفوظة {new Date().getFullYear()}
      </div>

      <SpecialOrderModal isOpen={openSpecial} onClose={() => setOpenSpecial(false)} />
    </footer>
  );
};

export default Footer;
